import TabularDataWithEffectiveDatesTableRow from "../tabularDataTable/TabularDataWithEffectiveDatesTableRow";
import _ from "underscore";
import TabularDataTableCell from "../tabularDataTable/TabularDataTableCell";
import TabularDataTableCellValidator from "../tabularDataTable/TabularDataTableCellValidator";
import TableCell from "../../../table/TableCell";
import WorkdayDurationsEditor from "../../../controls/WorkdayDurationsEditor";

function WorkdayDurationsTableRow() {}

WorkdayDurationsTableRow.prototype = _.create(TabularDataWithEffectiveDatesTableRow.prototype);

WorkdayDurationsTableRow.prototype.init = function(defaultSchedule, durationsCellIdx, deletable, effectiveDate, changesCallback) {
    TabularDataWithEffectiveDatesTableRow.prototype.init.call(this);
    this.validatableCells = [];
    this.defaultSchedule = defaultSchedule;
    this.deletable = deletable;
    this.changesCallback = changesCallback;
    this.markedAsDefault = false;
    this.oldEffectiveDate = null;
    return this;
};

WorkdayDurationsTableRow.prototype.setOldEffectiveDate = function(date) {
    this.oldEffectiveDate = date;
}

WorkdayDurationsTableRow.prototype.getOldEffectiveDate = function() {
    return this.oldEffectiveDate;
}

WorkdayDurationsTableRow.prototype.addCellObj = function(cellObj, validatable) {
    TabularDataWithEffectiveDatesTableRow.prototype.addCellObj.call(this, cellObj);
    if (validatable)
        this.validatableCells.push(cellObj);
};

WorkdayDurationsTableRow.prototype.canBeDeletedPermanently = function() {
    return this.deletable ? true : false;
};

WorkdayDurationsTableRow.prototype.validate = function() {
    var valid = true;
    for (var i = 0; i < this.validatableCells.length; i++) {
        this.validatableCells[i].validate(false);
        valid = valid && this.validatableCells[i].isValid();
    }
    return valid;
};


WorkdayDurationsTableRow.prototype.createDurationsCell = function(durations, durationsCellValidator, durationsCellRenderer) {
    var cell = new TabularDataTableCell();
    cell.init(durations, durationsCellValidator, this);
    cell.setRenderer(durationsCellRenderer);
    return cell;
};

WorkdayDurationsTableRow.prototype.createTotalCell = function(total, totalCellRenderer) {
    var cell = new TableCell(total);
    cell.setRenderer(totalCellRenderer);
    return cell;
};

WorkdayDurationsTableRow.prototype.createSetAsDefaultCell = function(isDefault, setAsDefaultCellRenderer) {
    var setAsDefaultCell = new TabularDataTableCell().init(isDefault, new TabularDataTableCellValidator().init(), this);
    setAsDefaultCell.setRenderer(setAsDefaultCellRenderer);
    return setAsDefaultCell;
};

WorkdayDurationsTableRow.prototype.setupTotalAndDefaultCellUpdates = function(totalCell, setAsDefaultCell, durationsCell, changeCallback) {
    var self = this;
    setAsDefaultCell.onChange(function() {
        self.setMarkedAsDefault(setAsDefaultCell.getValue() ? true : false);
        if (self.isMarkedAsDefault())
            durationsCell.setValue(self.defaultSchedule.slice());
        else if (changeCallback)
            changeCallback();
        durationsCell.updateUI();
        if (self.changesCallback)
            self.changesCallback();
    });

    durationsCell.onChange(function() {
        if (durationsCell.isValid()) {
            if (changeCallback)
                changeCallback();
            totalCell.setValue(WorkdayDurationsEditor.sumDurations(durationsCell.getValue()));
            totalCell.updateUI();
        }
    });
};


// Override it to avoid renderers substitution
WorkdayDurationsTableRow.prototype.writeCellsContent = function() {
    for (var i = 0; i < this.cells.length; i++) {
        var cell = this.cells[i];
        cell.writeContent();
    }
};

WorkdayDurationsTableRow.prototype.isEmpty = function()
{
    var effectiveDateCell = this.validatableCells[0];
    return effectiveDateCell.isEmpty();
};

WorkdayDurationsTableRow.prototype.hasErrors = function() {
    if (this.isMarkedToRemove())
        return false;

    for (var i = 0; i < this.validatableCells.length; i++)
        if (!this.validatableCells[i].isValid())
            return true;

    return false;
};

WorkdayDurationsTableRow.prototype.isMarkedAsDefault = function() {
    return this.markedAsDefault;
};

WorkdayDurationsTableRow.prototype.setMarkedAsDefault = function(markedAsDefault) {
    this.markedAsDefault = markedAsDefault;
};

export default WorkdayDurationsTableRow;



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/workScheduleTable/WorkdayDurationsTableRow.js